import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../../constants/breakpoints";
import { colors } from "../../../../constants/colors";

const styles = createUseStyles(theme => ({
  paymentsGrid: {
    margin: "32px 0 0 0",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "24px -32px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: "24px -16px",
    },
    "& .rdt_TableRow": {
      "& >div:last-child": {
        //position: "relative !important",
        right: "0px",
        backgroundColor: "inherit",
        //justifyContent: "flex-end"
      }
    },
    "& .rdt_TableCell": {
      padding: "16px 24px",
      minWidth: "155px",
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        padding: "12px 8px"
      },
    },
    "& .rdt_TableCol": {
      paddingLeft: "24px",
      paddingRight: "24px",
      minWidth: "155px",
      whiteSpace: "nowrap",
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    "& .rdt_TableCell:nth-last-child(2)": {
      paddingRight: 0,
      minWidth: "auto",
    },
    "& .rdt_TableCol:nth-last-child(2)": {
      paddingRight: 0,
      minWidth: "auto",
    },
    "& .rdt_TableCell:last-child": {
      paddingLeft: "24px",
      paddingRight: "20px",
      width: "50px",
      minWidth: "auto",
    },
    "& .rdt_TableCol:last-child": {
      paddingLeft: "24px",
      paddingRight: "20px",
      width: "50px",
      minWidth: "auto",
    },
  },
  assignBtn: {
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "10px 10px",
    },
    height: "40px",
  },
  disabledBtn: {
    "& svg": {
      "& path": {
        stroke: colors.darkGrey,
      },
    },
  },
  assignedName: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    lineHeight: "20px",
    "& span": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: colors.mediumGrey,
    },
    "& div": {
      display: "flex",
      padding: "2px 8px 2px 6px",
      backgroundColor: colors.veryLightGrey,
      borderRadius: "16px",
      gap: "4px",
      alignItems: "center",
      "& path": {
        stroke: colors.inactiveGrey
      }
    },
    "& p": {
      margin: 0,
      fontSize: "12px",
      fontWeight: "500",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: colors.grey,
      lineHeight: "18px"
    },
  },
  unassigned: {
    fontStyle: "italic",
    color: `${colors.darkGrey} !important`,
    cursor: "not-allowed",
    paddingRight: "5px"
  },
  assingBtnLoadingState: {
    backgroundColor: `${colors.white} !important`,
    border: theme.buttons.default.border,
    "& span": {
      borderColor: `${colors.grey} ${colors.grey} transparent !important`
    }
  },
  cardContainer: {
    display: "flex",
    gap: "12px",
    alignItems: "center"
  },
  cardDetails: {
    display: "flex",
    flexDirection: "column",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    overflow: "hidden !important",
  },
  cardIcon: {
    overflow: "visible !important"
  },
  cardNumberText: {
    whiteSpace: "initial",
    color: colors.lightBlack
  },
  redExpiredDate: {
    color: colors.error600
  },
  expiredDate: {
    color: colors.mediumGrey
  },
  link: {
    textDecoration: "none",
    color: colors.mediumGrey
  },
  nicknameText: {
    fontWeight: 400,
    color: colors.lightBlack
  },
}));

export default styles;
